import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // App-wide sane defaults. Per-query options ALWAYS override these (React
      // Query merges query options over client defaults), so hooks that pin
      // their own staleTime/refetch behavior (e.g. useNotes/useRecords
      // staleTime:0, the refetchInterval pollers, the long-cache
      // staleTime:Infinity hooks) are unaffected.
      // Data is fresh for 30s -> no background refetch within that window
      // (replaces the implicit staleTime:0 that refetched on every focus/mount).
      staleTime: 30_000,
      // Explicit but equal to the library default (5min) -> no behavior change.
      gcTime: 5 * 60_000,
      // Fail faster on genuinely broken requests (was the default 3).
      retry: 1,
      // Stop refetching every query on every tab focus. The one freshness-
      // critical path (chat in-flight self-heal in MessagesContext) does NOT use
      // React Query — it uses raw visibilitychange/online/setInterval listeners —
      // so it is unaffected. Queries that want focus-refetch can opt back in
      // per-query with refetchOnWindowFocus:true.
      refetchOnWindowFocus: false,
    },
  },
});
